import styled, { css } from 'styled-components';

export const Container = styled.div`
  margin-top: 30px;
`;

export const ChartWrapper = styled.div`
  position: relative;
`;

export const LabelsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  flex-wrap: wrap;
`;

export const LabelIcon = styled.div<{ color: string }>`
  background-color: ${(props) => props.color};
  width: 16px;
  height: 16px;
  margin: 0 5px 0 10px;
`;

export const ViewBubble = styled.div<{ autoHeight?: boolean; boosted?: boolean }>`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.75);
  width: ${({ boosted }) => (boosted ? 210 : 140)}px;

  border-radius: 8px;

  transition: 300ms all;
  pointer-events: none;

  ${({ autoHeight, boosted }) =>
    autoHeight
      ? css`
          height: auto;
          padding: 4px;
        `
      : css`
          height: ${boosted ? 60 : 50}px;
          padding-top: 4px;
        `}
`;

export const NoDataKey = styled.div`
  background-color: rgba(0, 0, 0, 0.04);
  width: 16px;
  height: 16px;
  border: 1px solid ${(props) => props.theme.keyline};
  margin-right: 10px;
`;
